import React from 'react';
import {convertValueToDollar} from 'common/utils';
import {FemaGoTable} from 'app-ui-componentlibrary';
import ActionSubApplicationModal from './actionSubApplicationModal';
import {map, get, isEmpty, find, chain} from 'lodash';

export const getRows = (columns, results, props) => {
  return map(results, (result) => {
    let cells = [];
    !props.readOnly &&
      cells.push(
        <FemaGoTable.CheckboxCell
          key={result.id + 'checkboxCell'}
          label={'Application ' + result.applicationTitle}
          hideLabel={true}
          collapsing={true}
          checked={chain(props)
            .get('cbResults', [])
            .find({entityId: result.entityId})
            .get('checked', false)
            .value()}
          handleChange={(label, value) => {
            props.handleCheckboxChange(result.entityId);
          }}
        />
      );

    cells = cells.concat(
      columns.map((column, index) => {
        let cell;
        if (column.type === 'currency') {
          cell = (
            <FemaGoTable.TextCell key={`currency-${result.id + index}`} textAlign="right">
              {convertValueToDollar(result[column.key])}
            </FemaGoTable.TextCell>
          );
        } else if (column.key === 'rank') {
          const rankError = get(props, [
            'errors',
            result.entityId,
            'rank',
            'errorMessage',
          ]);
          cell = !props.readOnly ? (
            <FemaGoTable.InputCell
              key={`rank-${result.id + index}`}
              width={2}
              rows={1}
              value={get(result, ['payload', column.key])}
              id={'rank' + result.applicationTitle}
              name={'payload.rank'}
              maxLength={3}
              handleBlur={(e) => {
                props.handleValidateAndSaveRank(result.entityId);
              }}
              handleChange={(e) => {
                const {value} = e.target;
                props.handleChange(result.entityId, 'payload.rank', value);
              }}
              displayError={!isEmpty(rankError)}
              errorMessages={rankError}
            />
          ) : (
            <FemaGoTable.TextCell key={result.applicationTitle + index}>
              {get(result, ['payload', column.key])}
            </FemaGoTable.TextCell>
          );
        } else if (column.type === 'actions') {
          cell = (
            <FemaGoTable.TextCell key={`actions-${result.id + index}`}>
              <ActionSubApplicationModal
                entityId={result.entityId}
                subApplicationId={result.subApplicationId}
                handleCardDelete={props.handleCardDelete}
                handleSave={props.handleSave}
                fedShareAmount={result.fedShareAmount}
                comments={result.comments}
                results={results}
                options={props.options}
                categoryLabel={props.categoryLabel}
                categoryOptions={props.categoryOptions}
              />
            </FemaGoTable.TextCell>
          );
        } else {
          cell = (
            <FemaGoTable.TextCell key={result.applicationTitle + index}>
              {result[column.key]}
            </FemaGoTable.TextCell>
          );
        }
        return cell;
      })
    );

    return <FemaGoTable.Row key={result.id}>{cells}</FemaGoTable.Row>;
  });
};

export const getHeaders = (masterChecked, columns, props) => {
  return [
    !props.readOnly && (
      <FemaGoTable.CheckboxCell
        key="headerCheckbox"
        isHeader
        label="Select all"
        className="header-checkbox"
        collapsing={true}
        width={2}
        checked={masterChecked}
        handleChange={(label, value) => props.handleMasterCheckbox(value)}
      />
    ),
    ...map(columns, (column) => {
      if (column.label === 'Federal share')
        return (
          <FemaGoTable.HeaderCell width={column.width} key={column.label} type="number">
            {column.label}
          </FemaGoTable.HeaderCell>
        );
      return (
        <FemaGoTable.HeaderCell key={column.label} width={column.width}>
          {column.label}
        </FemaGoTable.HeaderCell>
      );
    }),
  ];
};
